import qs from 'qs'
import axios from 'axios'
import cache from 'axios-cache-plugin/src'
import { t } from '@/locales/i18n'
import { getRouteNameByStudyTab } from '@/store/router/router'
import { sessionStore, uploadsBridge } from '@gto/gw-store'
import { SNK } from '@/helpers/helpers'
import router from '../../router'
// import mock_settings from './mocks/settings.json'
// import mock_plan from './mocks/plan.json'
// import mock_history from './mocks/history.json'
// import mock_solution from './mocks/solution.json'
// import mock_reports from './mocks/reports.json'
// import mock_reports_cards from './mocks/reports_cards.json'
// import mock_reports_cards_half_data from './mocks/reports_cards_half_data.json'
// import mock_shortcuts from './mocks/shortcuts.json'
// import mock_available_shortcuts from './mocks/available_shortcuts.json'
// import mock_coachings from './mocks/coachings.json'
// import mock_drills from './mocks/drills.json'
// import mock_drills_tags from './mocks/drills_tags.json'
// import bot_action from './mocks/bot_action.json'
// import available_nodeedits from './mocks/available_nodeedits.json'
// import practice_hand_detail from './mocks/practice_hand_detail.json'

let gwApiCache = {}

const updateGwApiCache = ({ gwCacheAdd, gwCacheId, gwCacheSkipOnError, error, response }) => {
  // TODO refactor this togetr with better cache mechanism
  if (gwCacheAdd && gwCacheId) {
    if (
      error &&
      gwCacheSkipOnError &&
      error.response?.status !== 403 &&
      error.response?.status !== 429
    ) {
      // do nothing
    } else {
      gwApiCache[gwCacheId] = { response, error }
    }
  }
}

const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
})
const errInterceptor = err => {
  const canceled = axios.isCancel(err)
  // console.log(err, err?.response, err?.request)
  if (err?.response) {
    // The client was given an error response (5xx, 4xx)
  } else if (err?.request) {
    // The client never received a response, and the request was never left
  } else if (!canceled) {
    console.log('Error', [err?.message, err])
  }

  const res = { ...err, canceled }
  return { error: res }
}
const resInterceptor = ({ ...response }) => ({ response })
const authInterceptor = config => {
  const { token, appUid, apiVersion } = config
  config.headers.GWCLIENTID = appUid
  if (config.hasAuth) {
    config.headers.Authorization = `Bearer ${token}`
  }
  if (config.customHeaders) {
    config.headers = {
      ...config.headers,
      ...config.customHeaders,
    }
  }
  if (apiVersion) {
    config.baseURL = config.baseURL.replace('v1', apiVersion)
  }
  return config
}

http.interceptors.request.use(authInterceptor)
http.interceptors.response.use(resInterceptor, errInterceptor)

const httpClient = cache(http, {
  maxCacheSize: 100,
})

// these endpoints are cached
httpClient.__addFilter(/\poker\/history/)
httpClient.__addFilter(/\poker\/bubble-factors/)

httpClient.__addFilter(/next-actions/)
httpClient.__addFilter(/plan/)
httpClient.__addFilter(/reports/)

httpClient.__addFilter(/shortcuts/)
httpClient.__addFilter(/\shortcuts\/available/)

httpClient.__addFilter(/\poker\/coaching\/lessons/)

const pendingCalls = {}

const actions = {
  async api_call(
    { commit, dispatch, getters, rootGetters },
    {
      hasAuth = true,
      ignoreNeedToRefresh = true,
      customHeaders,
      method = 'get',
      callId,

      gwCacheId,
      gwCacheAdd,
      gwCacheInvalidate,
      gwCacheSkipOnError = true,

      endpoint,
      params,
      data,
      message,
      action,
      actionArgs = {},
      actionAfter,
      actionAfterArgs = {},
      mutationArgs = {},
      mutation,
      fn,
      replace = false,
      mergeData,
      hasCancel = true,
      waitForCache = false, // api_poker_shortcuts - replace this with custom cache middleware
      cacheCancelIdPart = '',
      clearCacheOnError = false,
      isUpload,
      canceledLoadingValue = true,
      continueAfterCancel = false,
      dissIfSameCallInProgress = false,

      apiVersion = null,
      times = 0,
    },
  ) {
    let cachedApiCallRes = gwApiCache[gwCacheId]

    let response = null
    let error = null

    if (cachedApiCallRes) {
      // Refactor this --001
      response = cachedApiCallRes.response
      error = cachedApiCallRes.error
      if (gwCacheInvalidate) {
        delete gwApiCache[gwCacheId]
      }

      // TODO cache mechanism
      const cacheKeys = Object.keys(gwApiCache)
      if (cacheKeys.length > 100) {
        gwApiCache = {}
      }
    } else {
      if (mutation) {
        commit('api_update', {
          ...mutationArgs,
          key: mutation,
          result: {
            loading: true,
            response: null,
            error: null,
            loaded: false,
            method: method.toLocaleLowerCase(),
          },
          replace: false,
        })
      }

      // keep this err here - after while debuger will suffice for dev purposes
      // missing slash breaks safari /refresh somehow
      if (endpoint[endpoint.length - 1] !== '/') {
        debugger
        console.error(`api-missing-slash`, `${endpoint}`)
      }

      if (dissIfSameCallInProgress && pendingCalls[callId]) {
        if (cacheCancelIdPart) {
          pendingCalls[callId] = 'cacheAndContinue1+'
          // console.log('cacheAndContinue1+', callId)
        }
        return `same call in progress - dissed call - ${callId}`
      }

      callId = `${callId || endpoint}`

      // if (
      // endpoint === 'account/settings/'
      // endpoint === 'poker/shortcuts/' ||
      // endpoint === 'poker/solution/' ||
      // endpoint === 'poker/history/'
      // ) {
      // params = {
      // ...params,
      // cache_change: '2022-11-07T00:00Z',
      // }
      // }

      if (getters.needToRefresh && ignoreNeedToRefresh) {
        const sleep = ms =>
          new Promise(resolve => {
            setTimeout(resolve, ms)
          })
        const waitForRefresh = async () => {
          if (!getters.needToRefresh) {
            return true
          }
          await sleep(10)
          return waitForRefresh()
        }
        await waitForRefresh()
      }

      if (waitForCache && pendingCalls[callId]) {
        const sleep = ms =>
          new Promise(resolve => {
            setTimeout(resolve, ms)
          })
        const waitForLoaded = async () => {
          if (!pendingCalls[callId]) {
            return true
          }
          await sleep(10)
          return waitForLoaded()
        }
        await waitForLoaded()
        // console.log('1st shortcuts loaded')
      } else if (hasCancel && pendingCalls[callId]) {
        pendingCalls[callId].cancel()
        const sleep = ms =>
          new Promise(resolve => {
            setTimeout(resolve, ms)
          })
        const waitForCanceled = async () => {
          if (pendingCalls[callId]) {
            await sleep(10)
            return waitForCanceled()
          }
          return true
        }
        await waitForCanceled()
      } else if (cacheCancelIdPart) {
        Object.keys(pendingCalls).forEach(id => {
          if (id !== callId && id.includes(cacheCancelIdPart)) {
            pendingCalls[id] = 'cacheAndDiss'
            // console.log('cacheAndDiss', id)
          }
        })
      }

      const cancelTokenSource = axios.CancelToken.source()
      if (hasCancel || waitForCache) {
        pendingCalls[callId] = cancelTokenSource
      } else if (cacheCancelIdPart) {
        pendingCalls[callId] = 'cacheAndContinue'
        // console.log('cacheAndContinue', callId)
      }

      const accessToken = sessionStore.getState().accessToken
      const requestConf = {
        token: accessToken,
        appUid: sessionStore.getState().appUid,
        ...(hasCancel ? { cancelToken: cancelTokenSource.token } : {}),
        url: endpoint,
        method: method.toLowerCase(), // axios cachePlugin uses lowercase
        hasAuth,
        customHeaders,
        ...(apiVersion ? { apiVersion } : {}),
        ...(params ? { params } : {}),
        ...(data ? { data } : {}),
      }

      cachedApiCallRes = gwApiCache[gwCacheId]
      if (cachedApiCallRes) {
        // Refactor this --001
        response = cachedApiCallRes.response
        error = cachedApiCallRes.error
        if (gwCacheInvalidate) {
          delete gwApiCache[gwCacheId]
        }
        const cacheKeys = Object.keys(gwApiCache)
        if (cacheKeys.length > 100) {
          gwApiCache = {}
        }
      } else {
        const apiCallRes = await httpClient(requestConf)
        response = apiCallRes.response
        error = apiCallRes.error

        updateGwApiCache({ gwCacheAdd, gwCacheId, gwCacheSkipOnError, error, response })
      }
    }

    let result = {
      callId,
      method,
      response,
      error,
      loading: false,
      loaded: true,
      status: response?.status || error?.response?.status || error?.request?.status,
    }

    // console.log('FINISHED', callId)
    if (cacheCancelIdPart && pendingCalls[callId] === 'cacheAndDiss') {
      delete pendingCalls[callId]
      // console.log('DISSED', callId, 'rest--', pendingCalls)
      return result
    }
    // if (cacheCancelIdPart && pendingCalls[callId] === 'cacheAndContinue') {
    //   console.log('CONTINUE', callId, 'rest--', pendingCalls)
    // }
    // if (cacheCancelIdPart && pendingCalls[callId] === 'cacheAndContinue1+') {
    //   console.log('CALLED 1+ TIMES', callId, 'rest--', pendingCalls)
    // }

    delete pendingCalls[callId]

    if (error?.canceled) {
      result.loaded = false
      result.loading = canceledLoadingValue
    }

    if (error) {
      if (error.response) {
        const { status } = error.response
        if (error.response?.data?.code === 'user_inactive') {
          return error // staging only with not dev approved accounts
        }
        if (status === 401) {
          // debugger
          if (times >= 4) {
            console.error('multiple-refresh--logging-out', endpoint, times)
            dispatch('messages', {
              type: 'error',
              id: 'refresh_token_fail_logout',
              text: t('messages.refresh_token_fail_logout'),
            })
            dispatch('api_logout')
            return result
          }
          if (endpoint === '/token/refresh/') {
            // console.log(response, error, times)
            // debugger
            if (error.response?.data?.code === 'FORCED_LOGOUT') {
              dispatch('messages', {
                type: 'info',
                id: 'forced_logout',
                text: t('messages.forced_logout'),
                hideTimeout: 20000,
              })
            } else {
              dispatch('messages', {
                type: 'error',
                id: 'refresh_token_fail_logout',
                text: t('messages.refresh_token_fail_logout'),
                hideTimeout: 20000,
              })
            }
            dispatch('api_logout')
            return result
          }
          // if (endpoint === '/token/refresh/') {
          //   dispatch('api_logout')
          //   return result
          // }
          httpClient.__clearCache()

          let token = null

          if (!getters.needToRefresh) {
            const { token: newToken } = await dispatch('tokenRefresh')
            token = newToken
          }
          if (getters.needToRefresh || token) {
            return dispatch('api_call_retry', {
              hasAuth,
              ignoreNeedToRefresh,
              customHeaders,
              method,
              endpoint,
              params,
              data,
              message,
              action,
              actionArgs,
              actionAfter,
              actionAfterArgs,
              mutationArgs,
              mutation,
              fn,
              replace,
              hasCancel,
              isUpload,
              callId,

              gwCacheId,
              gwCacheAdd,
              gwCacheInvalidate,
              gwCacheSkipOnError,

              cacheCancelIdPart,
              clearCacheOnError,
              canceledLoadingValue,
              continueAfterCancel,
              dissIfSameCallInProgress,
              apiVersion,
              mergeData,
              times: times + 1,
            })
          }
          dispatch('api_logout')
        }
        if (status === 503) {
          result = {
            ...result,
            update: true,
          }
          if (error.response?.data?.code === 'MAINTENANCE') {
            dispatch('messages', {
              type: 'info',
              id: 'update_message',
              text: 'UPDATE IN PROGRESS. Thank you for your patience. </br> We will be right back.',
            })
            router.push({ name: 'Dashboard' }).catch(() => {})
          }
          // continue - if this happens in trainer it will get stuck
          // return result
        }
        if (status === 500) {
          const routeName = getRouteNameByStudyTab(router, rootGetters)
          let soltype = router.currentRoute.value.query.solution_type

          if (routeName === 'StudySolutions' && soltype === 'custom') {
            // let gametype = router.currentRoute.value.query.gametype
            // let stack = router.currentRoute.value.query.stack
            // let depth = router.currentRoute.value.query.depth

            soltype = `${soltype ? `-soltype-${soltype}` : ``}`
            // gametype = `${gametype ? `-gametype-${gametype}` : ``}`
            // stack = `${stack ? `-stack-${stack}` : ``}`
            // depth = `${depth ? `-depth-${depth}` : ``}`

            // console.error(`api-error-${status}-${routeName}${soltype}${gametype}${stack}${depth}`)
            console.error(`api-error-${status}-${routeName}${soltype}`)
          }
        }
      }
    }

    if (error?.canceled) {
      if (!continueAfterCancel) {
        return result
      }
    }

    if (!error?.canceled) {
      if (error && message?.type === 'error') {
        dispatch('messages', {
          type: 'error',
          error,
          endpoint,
          ...message,
        })
      } else if (message && message?.type !== 'error') {
        dispatch('messages', {
          type: message.type,
          result,
          endpoint,
          ...message,
        })
      }
    }

    if (error && clearCacheOnError) {
      dispatch('api_cache_clear')
    }

    // mocks --------
    // if (mutation === 'api_poker_practice_hand_detail') {
    //   result.response.data = practice_hand_detail
    //   result.response.status = 200
    //   console.log(result.response.data)
    // }

    // console.log(endpoint)
    // if (endpoint === 'poker/history/') {
    //   result.response.data = mock_history
    //   result.response.status = 200
    //   console.log(result.response.data)
    // }
    // console.log(endpoint)
    // if (endpoint === 'poker/solution/') {
    //   result = { response: { data: {} }, status: 0 }
    //   result.response.data = mock_solution
    //   result.response.status = 200
    //   console.log(result.response.data)
    // }
    // if (endpoint === 'poker/custom-solutions/available-node-edits/') {
    //   result.response.data = available_nodeedits
    //   result.response.status = 200
    //   console.log(result.response.data)
    // }
    // if (endpoint === 'account/settings/') {
    //   result.response.data = mock_settings
    //   result.response.status = 200
    //   console.log(result.response.data)
    // }
    // if (endpoint === 'payments/subscription/plan/') {
    //   result.response.data = mock_plan
    //   result.response.status = 200
    //   console.log(result.response.data)
    // }
    // if (endpoint === 'poker/shortcuts/available-shortcuts/') {
    //   result.response.data = mock_available_shortcuts
    //   result.response.status = 200
    //   console.log('mock_available_shortcuts', result.response.data)
    // }
    // if (endpoint === 'poker/shortcuts/') {
    //   result.response.data = mock_shortcuts
    //   result.response.status = 200
    //   console.log(result.response.data)
    // }
    // if (endpoint === 'poker/coaching/lessons/') {
    //   result.response.data = mock_coachings
    //   result.response.status = 200
    //   console.log(result.response.data)
    // }
    // if (endpoint === 'poker/practice/drills/') {
    //   result.response.data = mock_drills
    //   result.response.status = 200
    //   console.log(result.response.data)
    // }
    // if (endpoint === 'poker/practice/tags/') {
    //   result.response.data = mock_drills_tags
    //   result.response.status = 200
    //   console.log(result.response.data)
    // }
    // BE bug after all
    // http://localhost:8080/practice/trainer?gametype=Cash6m500zBasic&depth=100&depth_list=100&gmfft_sort_key=0&gmfft_sort_order=desc&preflop_actions=F-F-F-R2.5-F-C&flop_actions=X-X&turn_actions=R1.5&history_spot=8&board=QsTs7h7d7c&fh_start_spot=custom_spot&fh_hero=BB,BTN&fh_opponent=BB,BTN&fh_actions=SRP&fh_groups=22,33,44,55,66,77,88,99,AA,KK,QQ,JJ,TT,AKs,AKo,AQs,AJs,AQo,KQs,ATs,AJo,KJs,KQo,QJs,KTs,A9s,ATo,QTs,A8s,JTs,A7s,A5s,KJo,K9s,A4s,A6s,Q9s,A3s,T9s,QJo,J9s,A2s,KTo,A9o,K8s,QTo,K7s,JTo,Q8s,K6s,T8s,A8o,J8s,K5s,98s,A5o,A7o,K4s,K9o,Q7s,K3s,Q6s,A4o,T7s,A6o,K2s,J7s,Q9o,T9o,Q5s,97s,A3o,J9o,87s,Q4s,Q3s,A2o,K8o,76s,Q2s,J6s,T6s,J5s,65s,96s,86s,54s,K7o,J4s,Q8o,T8o,J3s,J8o,K6o,75s,98o,J2s,T5s,K5o,T4s,64s,53s,85s,95s,T3s,T2s,43s,Q7o,74s,T7o,J7o,97o,63s,87o,52s,93s,84s,94s,42s,92s,32s,73s,76o,65o,54o,62s,83s,82s,72s,K4o,Q6o,86o&fh_groups_selection=manual&fh_trainer_tables=1&fh_trainer_mode=stop_end_of_hand&fh_trainer_game_mode=trainer_actions&fh_trainer_grouping=swv_grouping_none&fh_trainer_result=after_mistake&fh_trainer_autoplay=0_sec&fh_trainer_game_speed=turbo&fh_trainer_hero_frequency=on&fh_trainer_quick_result=on&fh_trainer_hero_range=on&fh_trainer_opponent_range=on&fh_trainer_equity_chart=on&fh_trainer_ranges_comparison=on&fh_trainer_hand_strength=on&fh_trainer_total_frequency=on&fh_trainer_category_hands=on&fh_trainer_category_draws=on&fh_trainer_hero_strategy=on&fh_trainer_rng_visible=on&fh_trainer_streak_visible=on&soltab=reports
    // if (endpoint === 'poker/practice/bot-action/') {
    //   result.response.data = bot_action
    //   result.response.status = 200
    //   console.log(result.response.data)
    // }
    // -----

    updateGwApiCache({ gwCacheAdd, gwCacheId, gwCacheSkipOnError, error, response })
    if (fn) {
      // rename thi fn to something more easy to fullsearch and then fullsearch and replace :()
      fn({ ...result, ...actionArgs })
    }
    if (action && !error?.canceled) {
      dispatch(action, { ...result, ...actionArgs, actionArgs })
    }
    if (mutation) {
      commit('api_update', {
        ...mutationArgs,
        key: mutation,
        result,
        replace,
        mergeData,
      })
    }
    if (actionAfter && !error?.canceled) {
      dispatch(actionAfter, { ...result, ...actionAfterArgs, actionAfterArgs })
    }

    return result
  },

  api_logout({ state }) {
    const redirect = router.currentRoute.value.fullPath
    if (redirect === '/login') return
    httpClient.__clearCache()
    router.push({ name: 'Login' }).catch(() => {})
  },
  api_call_retry({ dispatch }, origParams) {
    const retryRes = dispatch('api_call', origParams)
    return retryRes
  },
  api_cancel_pending_requests({ getters }, { callIds } = {}) {
    Object.keys(pendingCalls).forEach(id => {
      if (callIds.some(e => id.includes(e))) {
        if (pendingCalls[id] && typeof pendingCalls[id].cancel === 'function') {
          pendingCalls[id].cancel()
        }
      }
    })
  },
  api_set_call_status_by_idpart({ getters }, { idPartsItems } = {}) {
    idPartsItems.forEach(i => {
      Object.keys(pendingCalls).forEach(id => {
        if (id.includes(i.idPart)) {
          pendingCalls[id] = i.status
          // console.log('setting status by idPart', id, i.status)
        }
      })
    })
  },
  api_cache_clear({ state, commit }) {
    httpClient.__clearCache()
  },
  api_add_uploads({ state, commit }, { files }) {
    uploadsBridge.trigger.startFilesUploading()
    const api_uploads = [...state.api_uploads, ...files]
    commit('api_uploads', api_uploads)
  },
  api_update_upload({ state, commit }, { callId, ...rest }) {
    const api_uploads = state.api_uploads.map(i => {
      if (i.callId === callId) {
        return { callId, ...rest }
      }
      return i
    })
    commit('api_uploads', api_uploads)
  },
  api_upload_next_file({ state, commit, dispatch }) {
    if (state.api_uploads.some(i => i.status === 'progress')) {
      return
    }
    const allFinished = state.api_uploads.every(
      i => i.status === 'finished' || i.status === 'error',
    )
    if (allFinished) {
      uploadsBridge.trigger.finishFilesUploading()
      commit('api_uploads', [])
      dispatch('globals_action', 'UploadedFilesTable')
      dispatch('account_settings')
      return
    }
    const uploadsInProgress = state.api_uploads.filter(i => i.status === 'progress')
    const uploadsWaiting = state.api_uploads.filter(i => i.status === 'waiting')
    if (uploadsWaiting.length && !uploadsInProgress.length) {
      const item = uploadsWaiting[0]
      dispatch('api_v2_poker_upload_file', item)
    }
  },
  gwApiCache_delete: ({ state, commit }, { id }) => {
    delete gwApiCache[id]
  },
}

const getters = {
  get_gwApiCache: state => () => gwApiCache,
}

function base() {
  return {
    // updated: -1,
    loading: false,
    loaded: false,
    status: 0,
    method: '',
    error: null,
    response: null,
  }
}

export { actions, getters, base }
